export default __webpack_public_path__ + "static/media/pupper.86c6de46.png";